import React from 'react';
import {Text} from '@/ui-kits';

export const SpecialistPatients: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB] p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-FigtreeBold font-bold text-ui_blue mb-2">
            Patients
          </h1>
          <p className="text-base sm:text-lg font-FigtreeRegular text-ui_input_border_dark">
            Manage your patient consultations and track patient information
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-ui_bg_light_blue p-8">
          <Text className="text-center text-lg font-FigtreeRegular text-ui_input_border_dark">
            Patients management interface will be implemented here
          </Text>
        </div>
      </div>
    </div>
  );
};

